import { useContext } from "react";
import { useSelector } from "react-redux";

import { FeatureCardContext } from "../../FeatureCard/components/FeatureCardHeader/FeatureCardContext";
import { DashboardContext } from "../components/DashboardContext";
import {
  getFeatureDataSources,
  getFeaturePage,
  getSelectedTabId as getFeatureSelectedTabId,
} from "../../../ducks/showFeature/selectors";
import {
  getGeometryFilter as getProjectGeometryFilter,
  getProjectDataSources,
  getProjectPage,
  getSelectedTabId as getProjectSelectedTabId,
} from "../../../ducks/project/selectors";
import { setSelectedTabId as setFeatureSelectedTabIdAction } from "../../../ducks/showFeature/showFeature";
import {
  setSelectedTabId as setProjectSelectedTabIdAction,
  toggleGeometryFilter as toggleGeometryFilterAction,
} from "../../../ducks/project/project";
import { useAction } from "../../../hooks/useAction";
import { WidgetType } from "../../FeatureCard/types";

export const useWidgetContext = (type: WidgetType) => {
  const featurePage = useSelector(getFeaturePage);
  const projectPage = useSelector(getProjectPage);
  const featureDataSources = useSelector(getFeatureDataSources);
  const projectDataSources = useSelector(getProjectDataSources);
  const featureSelectedTabId = useSelector(getFeatureSelectedTabId);
  const setFeatureSelectedTabId = useAction(setFeatureSelectedTabIdAction);
  const projectSelectedTabId = useSelector(getProjectSelectedTabId);
  const projectGeometryFilter = useSelector(getProjectGeometryFilter);
  const setProjectSelectedTabId = useAction(setProjectSelectedTabIdAction);
  const toggleGeometryFilter = useAction(toggleGeometryFilterAction);

  const {
    filters: featureFilters,
    changeFilters: featureChangeFilters,
    expandContainer: featureExpandContainer,
    expandedContainers: featureExpandedContainers,
    nextPage: featureNextPage,
    prevPage: featurePrevPage,
    changePage: featureChangePage,
  } = useContext(FeatureCardContext) || {};

  const {
    filters: projectFilters,
    changeFilters: projectChangeFilters,
    expandContainer: projectExpandContainer,
    expandedContainers: projectExpandedContainers,
    nextPage: projectNextPage,
    prevPage: projectPrevPage,
    changePage: projectChangePage,
  } = useContext(DashboardContext) || {};

  return {
    page: type === WidgetType.Dashboard ? projectPage : featurePage,
    filters: type === WidgetType.Dashboard ? projectFilters : featureFilters,
    changeFilters: type === WidgetType.Dashboard ? projectChangeFilters : featureChangeFilters,
    dataSources: type === WidgetType.Dashboard ? projectDataSources : featureDataSources,
    expandContainer: type === WidgetType.Dashboard ? projectExpandContainer : featureExpandContainer,
    expandedContainers: type === WidgetType.Dashboard ? projectExpandedContainers : featureExpandedContainers,
    selectedTabId: type === WidgetType.Dashboard ? projectSelectedTabId : featureSelectedTabId,
    setSelectedTabId: type === WidgetType.Dashboard ? setProjectSelectedTabId : setFeatureSelectedTabId,
    geometryFilter: type === WidgetType.Dashboard ? projectGeometryFilter : null,
    toggleGeometryFilter: type === WidgetType.Dashboard ? toggleGeometryFilter : null,
    nextPage: type === WidgetType.Dashboard ? projectNextPage : featureNextPage,
    prevPage: type === WidgetType.Dashboard ? projectPrevPage : featurePrevPage,
    changePage: type === WidgetType.Dashboard ? projectChangePage : featureChangePage,
  };
};
